import { isDefined } from '@vueuse/core';
import { isEqual } from 'lodash';

import { SemboDate } from '@libs/sembo-dates';
import type { ItinerarySearchUserCriteriaDependencies } from '@libs/trip-planner-interfaces';

export function hasChangedOnlySelectedDate(
  dependencies: ItinerarySearchUserCriteriaDependencies,
  oldDependencies: ItinerarySearchUserCriteriaDependencies
): boolean {
  const {
    selectedDate,
    startSearchDate,
    endSearchDate,
    ...dependenciesWihoutSelectedDate
  } = dependencies;
  const {
    selectedDate: oldSelectedDate,
    startSearchDate: oldStartSearchDate,
    endSearchDate: oldEndSearchDate,
    ...oldDependenciesWihoutSelectedDate
  } = oldDependencies;

  const hasSameSelectedDate =
    (!isDefined(selectedDate) && !isDefined(oldSelectedDate)) ||
    (isDefined(selectedDate) &&
      isDefined(oldSelectedDate) &&
      new SemboDate(selectedDate).isSame(oldSelectedDate));

  const hasSameStartSearchDate =
    (!isDefined(startSearchDate) && !isDefined(oldStartSearchDate)) ||
    (isDefined(startSearchDate) &&
      isDefined(oldStartSearchDate) &&
      new SemboDate(startSearchDate).isSame(oldStartSearchDate));

  const hasSameEndSearchDate =
    (!isDefined(endSearchDate) && !isDefined(oldEndSearchDate)) ||
    (isDefined(endSearchDate) &&
      isDefined(oldEndSearchDate) &&
      new SemboDate(endSearchDate).isSame(oldEndSearchDate));

  return (
    isEqual(
      dependenciesWihoutSelectedDate,
      oldDependenciesWihoutSelectedDate
    ) &&
    (!hasSameSelectedDate || !hasSameStartSearchDate || !hasSameEndSearchDate)
  );
}
